import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class MiscReportService {
  private apiUrl = '';

  constructor(private http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    this.apiUrl = baseUrl;
  }

  getFacilityGroups(userId: string, pharmacyId: number): Observable<any[]> {
    return this.http.get<any[]>(
      this.apiUrl + 'api/MiscReport/GetFacilityGroups/' + encodeURIComponent(userId) + '/' + pharmacyId
    );
  }

  postMiscReportRows(userId: string, payload: object): Observable<any[]> {
    return this.http.post<any[]>(
      this.apiUrl + 'api/MiscReport/GetMiscReportRows/' + encodeURIComponent(userId),
      payload
    );
  }

  postSendIncidentReportExcel(userId: string, formData: FormData): Observable<any> {
    return this.http.post(
      this.apiUrl + 'api/MiscReport/SendIncidentReportExcel/' + encodeURIComponent(userId),
      formData
    );
  }

  getPaymentMethodStatistics(
    userId: string,
    fromDate: string,
    toDate: string
  ): Observable<{ success: boolean; data?: any; message?: string }> {
    const qs =
      '?fromDate=' + encodeURIComponent(fromDate) +
      '&toDate=' + encodeURIComponent(toDate);
    return this.http.get<{ success: boolean; data?: any; message?: string }>(
      this.apiUrl + 'api/MiscReport/GetPaymentMethodStatistics/' + encodeURIComponent(userId) + qs
    );
  }

  getPaymentLinkSetupStatistics(
    userId: string,
    fromDate: string,
    toDate: string
  ): Observable<{ success: boolean; data?: any; message?: string }> {
    const qs =
      '?fromDate=' + encodeURIComponent(fromDate) +
      '&toDate=' + encodeURIComponent(toDate);
    return this.http.get<{ success: boolean; data?: any; message?: string }>(
      this.apiUrl + 'api/MiscReport/GetPaymentLinkSetupStatistics/' + encodeURIComponent(userId) + qs
    );
  }
}
